import { useEffect } from "react";

function setNamedMeta(name, content) {
  if (content == null || content === "") return;

  let element = document.head.querySelector(`meta[name="${name}"]`);
  if (!element) {
    element = document.createElement("meta");
    element.setAttribute("name", name);
    document.head.appendChild(element);
  }

  element.setAttribute("content", content);
}

function setPropertyMeta(property, content) {
  if (content == null || content === "") return;

  let element = document.head.querySelector(`meta[property="${property}"]`);
  if (!element) {
    element = document.createElement("meta");
    element.setAttribute("property", property);
    document.head.appendChild(element);
  }

  element.setAttribute("content", content);
}

function OpenGraph({ metadata }) {
  useEffect(() => {
    if (!metadata) return undefined;

    document.title = metadata.title;

    setNamedMeta("description", metadata.description);
    setPropertyMeta("og:title", metadata.title);
    setPropertyMeta("og:description", metadata.description);
    setPropertyMeta("og:image", metadata.image);
    setPropertyMeta("og:url", metadata.url);
    setPropertyMeta("og:type", metadata.type || "website");
    setPropertyMeta("og:site_name", metadata.siteName);

    if (metadata.locale) {
      setPropertyMeta("og:locale", metadata.locale);
    }

    if (metadata.alternateLocale) {
      setPropertyMeta("og:locale:alternate", metadata.alternateLocale);
    }

    if (metadata.imageAlt) {
      setPropertyMeta("og:image:alt", metadata.imageAlt);
    }

    setNamedMeta("twitter:card", metadata.twitterCard || "summary_large_image");
    setNamedMeta("twitter:title", metadata.title);
    setNamedMeta("twitter:description", metadata.description);
    setNamedMeta("twitter:image", metadata.image);

    return undefined;
  }, [metadata]);

  return null;
}

export default OpenGraph;
